module.exports = "https://www.gc-qa.gnp.com.mx/f40488b0e7f2f062cf5599b62a68cb4c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-cellphone.svg
// module id = 686
// module chunks = 0